import { useAuth } from '@/contexts/AuthContext';
import { Card, CardContent } from '@/components/ui/card';
import { useNavigate } from 'react-router-dom';
import { Package, BarChart3, Settings, LogOut, Receipt, Target, FileText, Heart, Car, Trophy, Gift, Landmark, ExternalLink, TrendingUp, CalendarDays, RefreshCw, HelpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const menuItems = [
  { icon: Receipt, label: 'Bills', path: '/bills', description: 'Track and pay recurring bills' },
  { icon: RefreshCw, label: 'Subscriptions', path: '/more/subscriptions', description: 'Audit detected recurring charges' },
  { icon: Landmark, label: 'Bank Sync', path: '/more/bank-sync', description: 'Connect and sync your bank accounts' },
  { icon: TrendingUp, label: 'Cash Flow Forecast', path: '/more/cash-flow', description: '30/60/90-day projected cash flow' },
  { icon: Target, label: 'Savings Goals', path: '/more/savings', description: 'Track progress toward savings targets' },
  { icon: Trophy, label: 'Savings Challenges', path: '/more/challenges', description: '52-week, round-ups & no-spend streaks' },
  { icon: FileText, label: 'Tax Time Wizard', path: '/more/tax-wizard', description: 'FY summary & PDF report for myTax' },
  { icon: Heart, label: 'Medicare & Health', path: '/more/medicare', description: 'Levy, surcharge & rebate calculator' },
  { icon: Car, label: 'Vehicles', path: '/more/vehicles', description: 'Fuel, rego, insurance & work deductions' },
  { icon: Package, label: 'Asset Database', path: '/more/assets', description: 'Track home items for insurance' },
  { icon: BarChart3, label: 'Reports & Charts', path: '/more/reports', description: 'Spending breakdowns & tax summary' },
  { icon: CalendarDays, label: 'Year in Review', path: '/more/year-in-review', description: 'Annual summary with PDF export' },
  { icon: Settings, label: 'Settings', path: '/more/settings', description: 'Export, import, change PIN' },
  { icon: HelpCircle, label: 'Help & Support', path: '/more/support', description: 'FAQs and contact support' },
  { icon: Gift, label: 'Refer a Friend', path: '/more/referral', description: 'Earn free Pro months for referrals' },
  { icon: ExternalLink, label: 'Inception Glen Products', path: '/more/inception-glen', description: 'Other apps by the same maker' },
];

export default function MorePage() {
  const { lock } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="px-4 pt-6">
      <h1 className="mb-4 font-display text-2xl font-bold">More</h1>

      <div className="space-y-2">
        {menuItems.map(item => (
          <Card key={item.path} className="cursor-pointer transition-colors hover:bg-muted/50" onClick={() => navigate(item.path)}>
            <CardContent className="flex items-center gap-3 p-4">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary/10">
                <item.icon className="h-5 w-5 text-primary" />
              </div>
              <div>
                <p className="font-medium">{item.label}</p>
                <p className="text-xs text-muted-foreground">{item.description}</p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      <Button variant="outline" className="mt-8 w-full gap-2" onClick={lock}>
        <LogOut className="h-4 w-4" />
        Lock App
      </Button>
    </div>
  );
}
